export const TENANT_TYPE_ESG = 'ESG';
export const TENANT_TYPE_PAST = 'PAST';
export const TENANT_STATUS_TYPES = [TENANT_TYPE_ESG, TENANT_TYPE_PAST];

export const SYSTEM_TENANT_NAME = 'SYSTEM';

export const TENANT_STATUS_ENABLED = "ENABLED";
export const TENANT_STATUS_DISABLED = "DISABLED";
export const TENANT_STATUSES = [TENANT_STATUS_ENABLED, TENANT_STATUS_DISABLED];
